import { getStore } from '../store/store';
import type { Calendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { mutatorAction } from 'satcheljs';

export const unselectOtherCalendars = mutatorAction(
    'UNSELECT_OTHER_CALENDARS',
    (calendar: Calendar) => {
        const foundCalendarResult = findInArray(getStore().selectedCalendars, item => {
            return item.id.id === calendar.id.id;
        });

        if (foundCalendarResult) {
            getStore().selectedCalendars = getStore().selectedCalendars.slice(
                foundCalendarResult.index,
                foundCalendarResult.index + 1
            );
        }
    }
);
